import React from "react";
import styles from "./index.module.scss";
import addFolderIcon from "../../../../../assets/images/add-folder-icon.png";

interface EmptyFoldersMessageProps {
  type: "noFolders" | "noFoldersForTab";
  handleAddFolder?: () => void;
  handleAddTab?: () => void;
}

const EmptyFoldersMessage: React.FC<EmptyFoldersMessageProps> = ({
  type = "noFolders",
  handleAddFolder,
  handleAddTab,
}) => {

  return (
    <div className={`${styles.noFolders} col-12 col-md-10`}>
      <div className={styles.noFoldersIcon}>
        <img src={addFolderIcon} alt="Add folder" />
      </div>
      <div className={styles.noFoldersText}>
        <>
          {type === "noFolders" ? (
            <>
              <strong>Space using tabs</strong> -{" "}
              <span onClick={() => handleAddTab?.()} className={styles.link}>
                Add tabs
              </span>{" "}
              and, then folders.
            </>
          ) : (
            <>
              Now, you can{" "}
              <span onClick={() => handleAddFolder?.()} className={styles.link}>
                add folders
              </span>{" "}
              to this tab
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default EmptyFoldersMessage;
